import * as React from 'react'
import { View, useWindowDimensions, StyleSheet, Text, TouchableOpacity, Image, Dimensions, ScrollView } from 'react-native'
import { TabView, SceneMap, TabBar } from 'react-native-tab-view'
import BenefitsList from './benefitsList'
import BenefitsHistoryList from './benefitsHistoryList'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 10,
    },
    redimesModule: {
        flex: 1,
        backgroundColor: 'white',
    },
    tabBar: {
        backgroundColor: 'white',
    },
    tabLabel: {
        color: theme.colors.darkGray,
        fontSize: 14,
        fontWeight: 'bold',
    },
    tabActive: {},
    tabIndicator: {
        backgroundColor: theme.colors.colorPrimary,
    },
    tab: {},
})

export default styles
